import { Flex, Text } from '@radix-ui/themes';
import React, { ReactNode } from 'react';
import './form-field.css';
export const FormField = ({
    label,
    error,
    children,
    required,
}: {
    children: ReactNode;
    required?: boolean;
    label: string;
    error?: string;
}) => {
    return (
        <Flex className="form-field" direction="column">
            <label>
                <Text as="div" size="2" mb="1" weight="regular" color="gray">
                    {label}
                    {required && (
                        <Text as="span" color="red" aria-required>
                            *
                        </Text>
                    )}
                </Text>
            </label>
            {children}
            {error && (
                <Text color="red" size="2" weight="regular">
                    {error}
                </Text>
            )}
        </Flex>
    );
};
